import { render, staticRenderFns } from "./WorkOrderRequestList.vue?vue&type=template&id=040ab95d&scoped=true&"
import script from "./WorkOrderRequestList.vue?vue&type=script&lang=js&"
export * from "./WorkOrderRequestList.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderRequestList.vue?vue&type=style&index=0&id=040ab95d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ab95d",
  null
  
)

export default component.exports